import { render } from "./AccountSubcontainer4.vue?vue&type=template&id=5ba7ba40&scoped=true"
import script from "./AccountSubcontainer4.vue?vue&type=script&lang=js"
export * from "./AccountSubcontainer4.vue?vue&type=script&lang=js"

import "./AccountSubcontainer4.vue?vue&type=style&index=0&id=5ba7ba40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ba7ba40"

export default script